/**
 * Singleton class to prevent duplicate metric submissions across multiple hook instances.
 * This is particularly useful in React StrictMode where components mount twice.
 */
export class MetricsLogger {
  private static instance: MetricsLogger
  private loggedSubmissions = new Set<string>()

  private constructor() {}

  static getInstance(): MetricsLogger {
    if (!MetricsLogger.instance) {
      MetricsLogger.instance = new MetricsLogger()
    }
    return MetricsLogger.instance
  }

  /**
   * Checks if a metric should be logged based on deduplication key.
   * @param deduplicationKey - The unique deduplication key for the metric
   * @returns boolean - true if should log, false if duplicate
   */
  shouldLogMetric(deduplicationKey: string): boolean {
    if (this.loggedSubmissions.has(deduplicationKey)) {
      return false // Already logged
    }

    this.loggedSubmissions.add(deduplicationKey)
    return true // Should log
  }
}
